module.exports = __webpack_public_path__ + "static/media/play-2.92cbf53f.svg";